import styled from 'styled-components'

export const MainContainer = styled.div`
  margin-top: 200px;
  padding: 0 20% 0 20%;
`

export const IconsContainer = styled.div`
  margin-top: 20px;
  display: grid;
  grid-gap: 15px;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
`

export const IconBox = styled.div`
  text-align: center;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  &:hover {
    cursor: pointer;
    border: 1px solid #c9c9c9;
    box-shadow: 1px 1px #c9c9c9;
    border-radius: 5px;
  }
`

export const IconsHeaderContainer = styled.div`
  @media screen and (max-width: 392px) {
    display: none;
  }
`